import QUIZ_STATE from '../enums/quizState'

const QUIZ_SCORING = {
    90: { state: QUIZ_STATE.MASTERED },
    60: { state: QUIZ_STATE.PASSED },
    0: { state: QUIZ_STATE.NOT_PASSED },
}

export default QUIZ_SCORING
